import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

export const openModalConfirmacao = ({
  title = 'Tem certeza que deseja realizar essa ação ?',
  descricao = 'Essa ação é irrevogável',
  funcSuccess = () => {},
  funcCancel = () => {},
}) => {
  confirm({
    title: title,
    icon: <ExclamationCircleOutlined />,
    content: descricao,
    okText: 'Sim',
    okType: 'danger',
    cancelText: 'Não',
    width: 500,
    onOk() {
      funcSuccess();
    },
    onCancel() {
      funcCancel();
    },
  });
};

openModalConfirmacao.propTypes = {
  title: PropTypes.string,
  descricao: PropTypes.string,
  funcSuccess: PropTypes.func,
  funcCancel: PropTypes.func,
};

openModalConfirmacao.defaultProps = {
  // title: 'Tem certeza que deseja realizar essa ação ?',
  // descricao: 'Essa ação é irrevogável',
  // funcSuccess: () => {},
  // funcCancel: () => {},
};
